import React from "react";
import { states } from "LIB/states";
import { FormInput, Select } from "MODULES/shared/components/Forms";
import * as F from "MODULES/shared/components/Forms/FormTypes";

export default function State({ country, state, ...props }) {
  if (country.input.value === "US") {
    return (
      <Select
        options={states}
        label="State/Province/Region"
        {...state}
        {...props}
      />
    );
  }

  return <FormInput label="State/Province/Region" {...state} {...props} />;
}

State.propTypes = {
  country: F.formField(F.stringInput).isRequired,
  state: F.formField(F.stringInput).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ShippingSection/State.jsx